/**
 * NOT CHECKED
 */
import React, { useState, useEffect } from 'react';
import cn from 'class-names';

import './Tabs.scss';
import HorizontalScrollWithArrows from '@uikit/old/HorizontalScrollWithArrows/HorizontalScrollWithArrows';
import { SVGIcon } from '@uikit/old/Icon/Icon';

export type TabConfigType = {
  title?: string;
  renderTitle?: (isActive?: boolean) => JSX.Element;
  key: string;
  renderContent: () => JSX.Element;
  icon?: string;
  iconType?: 'fill' | 'stroke';
};

type TabsPropsType = {
  tabs: TabConfigType[];
  activeTab?: string;
  /** data-testid on the tabs root; each tab title gets `${testId}-tab-${key}` */
  testId?: string;
};

function Tabs({ tabs, activeTab, testId }: TabsPropsType): JSX.Element {
  const [activeTabKey, changeActiveTabKey] = useState(null);

  useEffect(() => {
    if (activeTabKey === null && tabs.length > 0) {
      changeActiveTabKey(tabs[0].key);
    }
  }, [tabs]);

  useEffect(() => {
    if (activeTab) {
      changeActiveTabKey(activeTab);
    }
  }, [activeTab]);

  const getTabTitleClassName = (tabKey: string): string =>
    cn('tabs__tab-title', {
      'tabs__tab-title--active': tabKey === activeTabKey,
    });

  const { renderContent: RenderActiveContent } = tabs.find(({ key }) => key === activeTabKey) || {};

  return (
    <div className="tabs" data-testid={testId}>
      <HorizontalScrollWithArrows withBottomBorder={false}>
        <div className="tabs__list">
          {tabs.map(({ title, key, renderTitle, icon, iconType }) => (
            <div
              className={`${getTabTitleClassName(key)} ${iconType}-icon`}
              key={key}
              onClick={() => changeActiveTabKey(key)}
              data-testid={testId ? `${testId}-tab-${key}` : undefined}
            >
              {icon ? <SVGIcon icon={icon as any} /> : null}
              {renderTitle ? renderTitle(key === activeTabKey) : title}
            </div>
          ))}
        </div>
      </HorizontalScrollWithArrows>
      <div className="tabs__active-content">
        {RenderActiveContent ? <RenderActiveContent /> : null}
      </div>
    </div>
  );
}

export default Tabs;
